export default __webpack_public_path__ + "static/media/TEGGallery.9504297e.jpg";